"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderActionCreators = exports.OrderActionTypes = void 0;
var OrderActionTypes;
(function (OrderActionTypes) {
    OrderActionTypes["Change"] = "Order.Change";
    OrderActionTypes["Insert"] = "Order.Insert";
    OrderActionTypes["Delete"] = "Order.Delete";
    OrderActionTypes["GetInOrdersBalance"] = "Order.GetInOrdersBalance";
})(OrderActionTypes = exports.OrderActionTypes || (exports.OrderActionTypes = {}));
class OrderActionCreators {
}
exports.OrderActionCreators = OrderActionCreators;
OrderActionCreators.change = (order) => ({
    type: OrderActionTypes.Change,
    order,
});
OrderActionCreators.insert = (order) => ({
    type: OrderActionTypes.Insert,
    order
});
OrderActionCreators.delete = (order) => ({
    type: OrderActionTypes.Delete,
    order
});
OrderActionCreators.getInOrdersBalance = () => ({
    type: OrderActionTypes.GetInOrdersBalance,
});
//# sourceMappingURL=order.js.map